import React from "react";
import { EChartsOption } from "echarts";

import { BaseChart } from "./BaseChart";
import { LoadingChartIndicator } from "./LoadingChartIndicator";

export interface IPieData {
    name: string;
    value: number;
}

export interface IChartProps {
    data: IPieData[];
}

export const PieChart: React.FC<IChartProps> = ({ data }) => {
    if (data.length === 0) {
        return <LoadingChartIndicator />;
    }

    const count: { [key: string]: number } = {};
    data.forEach(_ => (count[_.name] = (count?.[_.name] || 0) + _.value));

    const filteredData: IPieData[] = (Object.keys(count) || [])
        .filter(key => count[key] > 0)
        .map(key => ({
            name: key,
            value: parseFloat(count[key].toFixed(3)),
        }));

    const option: EChartsOption = {
        backgroundColor: "#2D3855",
        tooltip: {
            trigger: "item",
            backgroundColor: "#000000",
            borderColor: "#000000",
            padding: [20, 20],
            textStyle: {
                color: "#FFFFFF",
                fontSize: 13,
                fontWeight: 400,
                lineHeight: 20,
            },
        },
        legend: {
            show: false,
        },
        series: {
            type: "pie",
            radius: ["65%", "70%"],
            labelLine: {
                show: false,
            },
            label: {
                show: true,
                fontSize: 10,
                lineHeight: 18,
                color: "#BAC4E2",
                distanceToLabelLine: -5,
                fontWeight: 700,
            },
            emphasis: {
                label: {
                    fontSize: 14,
                    lineHeight: 22,
                    fontWeight: "bold",
                },
            },
            itemStyle: {
                borderWidth: 10,
            },
            color: [
                "rgb(32, 160, 255)", // royalBlue
                "rgb(234, 113, 157)", // red
                "rgb(169,97,228)", // purple
                "rgb(248,153,115)", // orange
                "#2EC495", // green
                "#F9C36E", // yellow
            ],
            data: filteredData,
        },
    };

    return <BaseChart option={option} />;
};
